export const API_KEY = "AIzaSyAeFaDOAv5goABYEdn-8ovjSdlIbjRRrBE";

export default API_KEY;